const UUID_REGEX = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/

/** Returns the first UUID found in the given string, or `undefined` if none are found. */
export const extractUUID = (str: string): string | undefined => {
  return new RegExp(UUID_REGEX).exec(str)?.[0] ?? undefined
}
